import * as tus from "tus-js-client";

// Chunked upload through our backend → Emergent Object Storage (bypasses proxy size limits).
export async function chunkedUpload(id, file, chunkFn, onProgress) {
  const CH = 5 * 1024 * 1024;
  let sent = 0;
  for (let o = 0; o < file.size; o += CH) {
    const blob = file.slice(o, Math.min(o + CH, file.size));
    await chunkFn(id, blob);
    sent += blob.size;
    if (onProgress) onProgress(Math.round((sent * 100) / file.size));
  }
}

// Resumable chunked upload (tus) straight to Cloudflare — any size, survives network hiccups.
export function tusToCloudflare(uploadURL, file, onProgress) {
  return new Promise((resolve, reject) => {
    const up = new tus.Upload(file, {
      uploadUrl: uploadURL,
      chunkSize: 50 * 1024 * 1024,
      retryDelays: [0, 2000, 5000, 10000, 20000],
      onProgress: (sent, total) => onProgress && onProgress(Math.round((sent * 100) / total)),
      onSuccess: () => resolve(),
      onError: (e) => reject(new Error(e?.originalResponse ? `Cloudflare rejected the upload (${e.originalResponse.getStatus()})` : "Upload interrupted — check your connection and try again")),
    });
    up.start();
  });
}

export function uploadToCloudflare(uploadURL, file, onProgress, isTus = false) {
  if (isTus) return tusToCloudflare(uploadURL, file, onProgress);
  return new Promise((resolve, reject) => {
    const body = new FormData();
    body.append("file", file);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", uploadURL);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded * 100) / e.total));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
    xhr.onerror = () => reject(new Error("Network error during upload"));
    xhr.send(body);
  });
}
